import CancelDialog from "src/components/core-components/mui/CancalDialog";
import { useTranslate } from "src/locales";

//CKAPISIZ;452953;05052025
interface RefectoryDietCancelPopupProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}

export default function RefectoryDietCancelPopup({
  open,
  onClose,
  onConfirm,
}: RefectoryDietCancelPopupProps) {
  const { t } = useTranslate();
  return (
    <CancelDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={t("warning-Message")}
      description={t("confirmation-text")}
      placeholder={t("description-required")}
      extraAction={{
        label: t("add-predefined-text"),
        onClick: () => console.log("Hazır Metinler"),
        icon: <img src="/assets/icons/add/add2.svg" alt="Plus Icon" />,
        sx: {
          bgcolor: "#63B4FF33",
          color: "#2979C3",
          border: "1px solid #2979C3",
        },
      }}
      cancelText={t("no")}
      confirmText={t("yes")}
      requireInput={true}
      width="650px"
      height="420px"
    />
  );
}